import classNames from "classnames";
import styles from "./style.module.scss";
import { Icons } from "assets";

interface CustomSearchProps extends React.HTMLProps<HTMLInputElement> {}

const CustomSearch = ({
  placeholder = "Search here",
  value,
  onChange,
}: CustomSearchProps) => {
  return (
    <div className={classNames(styles.searchContainer)}>
      <input
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={onChange}
      />
      <span className={classNames(styles.iconContainer)}>
        <Icons.Search />
      </span>
    </div>
  );
};

export default CustomSearch;
